import { render, staticRenderFns } from "./infoMsg.vue?vue&type=template&id=1a85b2af&scoped=true&"
import script from "./infoMsg.vue?vue&type=script&lang=js&"
export * from "./infoMsg.vue?vue&type=script&lang=js&"
import style0 from "./infoMsg.vue?vue&type=style&index=0&id=1a85b2af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a85b2af",
  null
  
)

export default component.exports